function game_303()
{

}

game_303.odd_map  = {
  "9":[0,0,100,350,1000],
  "8":[0,0,50,200,500],
  "7":[0,0,30,40,350],
  "6":[0,0,20,40,200],
  "5":[0,0,10,20,100],
  "4":[0,0,10,20,100],
  "3":[0,0,5,10,50],
  "2":[0,0,5,10,50],
  "1":[0,0,5,10,50],
};

export {
  game_303
};



// WEBPACK FOOTER //
// ./src/components/slots/game_303.js